"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.skeletonAttrs = skeletonAttrs;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _box = _interopRequireDefault(require("@ux/box"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UX_SKELETON_CLASSNAME = 'ux-skeleton';
const UX_SKELETON_ROUNDING = ['default', 'none', 'full'];
const UX_SKELETON_SIZES = {
  'xs': 'calc(var(--skeletonHeightDefault) * 0.75)',
  'sm': 'calc(var(--skeletonHeightDefault) * 1)',
  'md': 'calc(var(--skeletonHeightDefault) * 1.5)',
  'lg': 'calc(var(--skeletonHeightDefault) * 2)',
  'xl': 'calc(var(--skeletonHeightDefault) * 2.5)',
  '2xl': 'calc(var(--skeletonHeightDefault) * 3.5)'
};

/**
 * Creates a Skeleton component
 * @param {Object} props - Component properties
 * @param {String} props.className - Optional class name
 * @param {(Number | String)} props.height - Custom component height that overrides the height set by `size`
 * @param {Number} props.lines - Number of lines to render for text placeholders
 * @param {String} props.rounding - Component corner rounding (defaults to `ux.box.borderRadius` defined in the theme)
 * @param {('xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl')} props.size - T-shirt size that sets component height and width
 * @param {(Number | String)} props.width - Custom component width that overrides the width set by `size`
 * @returns {React.ReactComponentElement} Skeleton component
 */
function Skeleton(_ref) {
  let {
    className,
    height,
    lines = 1,
    rounding = 'default',
    size,
    width
  } = _ref;
  const itemSize = size ? UX_SKELETON_SIZES[size] : null;
  const itemHeight = height ? height : itemSize;

  /* eslint-disable no-console, no-process-env */
  if (process.env.NODE_ENV !== 'production' && size) {
    const warnings = [];
    if (height) {
      warnings.push('"height"');
    }
    if (width) {
      warnings.push('"width"');
    }
    if (warnings.length > 0) {
      console.warn(`@ux/skeleton: The ${warnings.join(' and ')} prop(s) will override the "size" prop.`);
    }
  }
  /* eslint-enable no-console, no-process-env */

  let borderRadius;
  if (rounding === 'none') {
    borderRadius = '0';
  } else if (rounding === 'full') {
    borderRadius = itemHeight || 'var(--skeletonHeightDefault)';
  } else {
    borderRadius = 'var(--skeletonRoundingDefault)';
  }
  const styles = {
    borderRadius,
    height: itemHeight,
    width: width ? width : itemSize
  };
  const item = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(UX_SKELETON_CLASSNAME, className),
    style: styles
  });

  /**
   * Renders multiple Skeleton items
   * @param {number} count - Number of items to render (gets passed from the `lines` prop)
   * @returns {React.ReactElement} Box component with the specified number of Skeleton items
   */
  function renderItems(count) {
    const items = [];
    for (let i = 0; i < count; i++) {
      items.push( /*#__PURE__*/_react.default.cloneElement(item, {
        key: i
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_box.default, {
      className: (0, _classnames.default)(`${UX_SKELETON_CLASSNAME}--text`, className),
      orientation: "vertical",
      gap: "sm"
    }, items);
  }
  return lines > 1 ? renderItems(lines, item) : item;
}
Skeleton.propTypes = {
  /** Optional class name */
  className: _propTypes.default.string,
  /** Custom component height that overrides the height set by `size` */
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /** Number of lines to render for text placeholders */
  lines: _propTypes.default.number,
  /** Component corner rounding (defaults to `ux.box.borderRadius` defined in the theme) */
  rounding: _propTypes.default.oneOf(UX_SKELETON_ROUNDING),
  /** T-shirt size that sets component height and width */
  size: _propTypes.default.oneOf(Object.keys(UX_SKELETON_SIZES)),
  /** Custom component width that overrides the width set by `size` */
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};

/**
 * Adds accessibility attributes. Meant to be spread onto the loading layout wrapper.
 * @returns {Object} - Accessibility attributes
 */
function skeletonAttrs() {
  return {
    'aria-busy': true,
    'aria-live': 'polite',
    'role': 'status'
  };
}
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Skeleton);